<template>
  <breeze-authenticated-layout>
    <template #header>
      <h2 class="font-semibold text-xl text-gray-800 leading-tight">Members</h2>
    </template>

    <div class="py-12">
      <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
          <div class="p-6 bg-white border-b border-gray-200">
            <manage />
          </div>
        </div>
      </div>
    </div>
  </breeze-authenticated-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'
import Manage from '@/Components/UserCardio/manage'

export default {
  name: 'manage-page',
  components: {
    BreezeAuthenticatedLayout,
    Manage,
  },
  props: {
    week: Object,
    weeks: Array,
    lists: Array,
    challenges: Array,
    organization: Object,
    habit: Object,
  },
  mounted() {
    this.setSummary({
      week: this.week,
      weekCoach: this.week,
      weeks: this.weeks,
      lists: this.lists,
      challenges: this.challenges,
      organization: this.organization,
      habit: this.habit,
    })
  },
  computed: {
    ...mapGetters('usercardio', ['summary']),
  },
  methods: {
    ...mapActions('usercardio', ['setSummary']),
  },
}
</script>
